import { useEffect, useState } from 'react';

import { useHasSeenSpotlight } from '@netfront/gelada-identity-library';
import Joyride, { CallBackProps, STATUS } from 'react-joyride';

import { SPOTLIGHT_DISPLAY_TIMEOUT_IN_MILLISECONDS } from './Spotlight.constants';
import { ISpotlight, SpotlightProps } from './Spotlight.interfaces';

const Spotlight = ({ disableOverlayClose, disableCloseOnEsc, hideCloseButton, spotlightItem, onSpotLightData }: SpotlightProps) => {
  const [spotlightTour, setSpotlightTour] = useState<ISpotlight>(spotlightItem);
  const [isMounted, setIsMounted] = useState<boolean>(false);

  const { handleHasSeenSpotlight } = useHasSeenSpotlight({
    onCompleted: ({ hasSeenSpotlight }) => {
      if (hasSeenSpotlight) {
        return;
      }

      setTimeout(() => {
        handleSpotlightStart();
      }, SPOTLIGHT_DISPLAY_TIMEOUT_IN_MILLISECONDS);
    },
  });

  const handleSpotlightCallback = (data: CallBackProps) => {
    const { status } = data;

    onSpotLightData(data);

    const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setSpotlightTour({
        ...spotlightTour,
        run: true,
      });
    }
  };

  const handleSpotlightStart = () => {
    setSpotlightTour({
      ...spotlightTour,
      run: true,
    });
  };

  useEffect(() => {
    handleHasSeenSpotlight({ url: window.location.pathname });
    setIsMounted(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return isMounted ? (
    <div>
      <Joyride
        callback={handleSpotlightCallback}
        continuous={true}
        disableCloseOnEsc={disableCloseOnEsc}
        disableOverlayClose={disableOverlayClose}
        hideCloseButton={hideCloseButton}
        run={spotlightTour.run}
        scrollToFirstStep={true}
        showSkipButton={true}
        steps={spotlightTour.steps}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
        locale={{
          next: `Next`
        }}
      />
    </div>
  ) : null;
};

export { Spotlight };
